import { TabIds } from "features/CenterContent/RoleContent/useTabsForRole";
import { FC } from "react";
import { generatePath, Navigate, useLocation } from "react-router-dom";
import { UserRole } from "shared/types/roles";

// DASHBOARD ROUTE CONSTANTS
export const DASHBOARD = "/dashboard";

export const LANDING = `${DASHBOARD}/landing/:roleIdParam/:tabIdParam`;
export const TRAIN = `${DASHBOARD}/train/:countryCode/:trainNumber/:trainDate`;
export const BUS = `${DASHBOARD}/bus/:vehicleUuid`;
export const RESERVEBUS = `${DASHBOARD}/reservebus/:vehicleUuid`;
export const BACKUPBUS = `${DASHBOARD}/backupbus/:vehicleUuid`;
export const ALTERNATIVE_TRANSPORT_INFRASTRUCTURE_EVENT_DEPRECATED = `${DASHBOARD}/infrastructure-event/:infrastructureEventId`;
export const ALTERNATIVE_TRANSPORT_DECISION_SUPPORT = `${DASHBOARD}/decision-support/:uuid`;

// HISTORY ROUTE CONSTANTS
export const HISTORY = "/history";

// OPLOGG ROUTE CONSTANTS
export const OPLOGG = "/oplogg";

export const DETAIL = `${HISTORY}/detail/:eventTypeParam/:eventUuidParam`;

// UTIL ROUTE CONSTANTS
const _LOGIN_REDIRECT = "/login-redirect";
export const PUZZEL_CALLBACK = "/puzzel-callback";
// Lands here after Puzzel's own logout completes, to then finish signing out of Vy/Entra.
export const PUZZEL_LOGOUT_CONTINUE = "/puzzel-logout-continue";

// UTIL GITHUB VERSION
export const VERSION = "/version";

export const getDashboardStartPath = (role: UserRole) =>
  generatePath(LANDING, { roleIdParam: role, tabIdParam: TabIds.START });

export const DashboardRedirect: FC = () => {
  const location = useLocation();
  return <Navigate to={`${DASHBOARD}${location.pathname}`} replace />;
};
